export default "__VITE_ASSET__BwH$oeOQ__"